import { Routes } from '@angular/router';
import { LoginComponent } from './Modules/login/login.component';
import { MasterReportingComponent } from './Modules/master-reporting/master-reporting.component';
import { ExpenseComponent } from './Modules/expense/expense.component';
import { authGuard } from './Core/guards/auth.guard';
import { roleGuard } from './Core/guards/role.guard';
import { SupportComponent } from './Modules/support/support.component';
import { CrmComponent } from './Modules/crm/crm.component';

export const routes: Routes = [

  {
    path: 'login',
    component: LoginComponent,
    canActivate: [authGuard ],
    // canActivate: [],
  },
  {
    path: 'master-reporting',
    component: MasterReportingComponent,
    canActivate: [authGuard, roleGuard ],
    data: { expectedRoles: ['MASTER_ADMIN'] }
  },
  {
    path: 'crm',
    canActivate: [authGuard, roleGuard],
    data: { expectedRoles: ['OWNER','MASTER_ADMIN','SUPER_ADMIN','CRM_ADMIN','ADMIN','AGENT'] }, // Base CRM permission
    children: [
      {
        path: 'general',
        component: CrmComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['OWNER','MASTER_ADMIN','SUPER_ADMIN','CRM_ADMIN','ADMIN','AGENT'] }
      },
      // {
      //   path: 'general/:id',
      //   component: CrmComponent,
      //   canActivate: [roleGuard],
      //   data: { expectedRoles: ['MASTER_ADMIN'] }
      // },
      // {
      //   path: 'agent/:id',
      //   component: CrmComponent,
      //   canActivate: [roleGuard],
      //   data: { expectedRoles: ['MASTER_ADMIN'] }
      // },
      // {
      //   path: 'inhouse/:id',
      //   component: CrmComponent,
      //   canActivate: [roleGuard],
      //   data: { expectedRoles: ['MASTER_ADMIN'] }
      // },
      {
        path: 'agent',
        component: CrmComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['OWNER','MASTER_ADMIN','SUPER_ADMIN','CRM_ADMIN','ADMIN'] } // Granular permission
      },
      {
        path: 'inhouse',
        component: CrmComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['OWNER','MASTER_ADMIN','SUPER_ADMIN','CRM_ADMIN','ADMIN'] } // Granular permission
      },
      {
        path: 'test',
        component: CrmComponent,
        canActivate: [roleGuard],
        data: { expectedRoles: ['OWNER','MASTER_ADMIN','SUPER_ADMIN','CRM_ADMIN','ADMIN'] } // Granular permission
      },
      { path: '', redirectTo: 'general', pathMatch: 'full' }
    ]
  },
  {
    path: 'expenses',
    component: ExpenseComponent,
    canActivate: [authGuard, roleGuard ],
    data: { expectedRoles: ['OWNER'] }
  },
  {
    path: 'support',
    component: SupportComponent,
    canActivate: [authGuard, roleGuard ],
    data: { expectedRoles: ['MASTER_ADMIN'] }
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [authGuard ],
  },
];
